module.exports = __webpack_public_path__ + "img/wechat.36625983.svg";